import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';

interface Props {
  size: number;
  color: string;
}

export default function ProductsIconOutline({ size, color }: Props) {
  return (
    <WidgetsOutlinedIcon sx={{ fontSize: size, color }} />
  )
}
